"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyEllipsis = void 0;
var styled_components_1 = require("styled-components");
exports.applyEllipsis = function () {
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    "], ["\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    "])));
};
var templateObject_1;
//# sourceMappingURL=applyEllipsis.js.map